import { DonationOption } from 'autogen/swagger/all';
import { Button } from 'components/Button';
import IButton from 'components/Button/shared/types/button';
import UAEventTracking from 'modules/tracking/UAEventTracking';

interface IDonationButton extends IButton {
    ctaText: DonationOption['ctaText'];
    linkAction: DonationOption['addToBasketLinkAction'];
}

export default function OptionButton({ ctaText, linkAction, ...rest }: IDonationButton): JSX.Element {
    return (
        <Button
            {...rest}
            variant="secondary"
            size="sm"
            onClick={() => {
                UAEventTracking({ eventCategory: 'donation', eventAction: 'addToBasket', eventLabel: ctaText });
            }}
            data-js-cart={linkAction.url}
        >
            {ctaText}
        </Button>
    );
}
